import { render, staticRenderFns } from "./LabelCornerBottomRightIcon.vue?vue&type=template&id=8b09f6f6&"
import script from "./LabelCornerBottomRightIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCornerBottomRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports